import { render, staticRenderFns } from "./MySwiperSlide.vue?vue&type=template&id=0d2c159a&scoped=true&"
import script from "./MySwiperSlide.vue?vue&type=script&lang=js&"
export * from "./MySwiperSlide.vue?vue&type=script&lang=js&"
import style0 from "./MySwiperSlide.vue?vue&type=style&index=0&id=0d2c159a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c159a",
  null
  
)

export default component.exports